// src/lib.ts
var escaped = {
  "&quot;": '"',
  "&#39;": "'",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">"
};
var descape = (string) => string.replace(/&(quot|#39|amp|lt|gt);/g, (match) => escaped[match]);
var isDataUrl = (url) => url.startsWith("data:") || url.startsWith("#");
var isEmptyString = (url) => url === "";
var filterer = (url) => !isDataUrl(url) && !isEmptyString(url);
var getImageUrlsFromHtml = (html) => {
  const regex = /<(?:img|image).*?(?:href|src)=(["|'])(.*?)(\1)/gm;
  const urls = Array.from(html.matchAll(regex)).map((match) => match[2]).filter(filterer);
  return urls;
};
var getUrlsFromCss = (cssRuleString) => {
  const regex = /url\((.*?)\)/gi;
  const urls = Array.from(cssRuleString.matchAll(regex)).map((match) => removeQuotes(match[1])).filter(filterer);
  return urls;
};
var removeQuotes = (str) => str.replace(/^("|').*?(\1)$/gm, (match) => match.slice(1, -1));

// src/fetcher.ts
var fetcher = (url) => {
  return new Promise(async (resolve) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => resolve("");
      reader.readAsDataURL(blob);
    } catch {
      return resolve("");
    }
  });
};

// src/index.ts
var serialize = (node) => new XMLSerializer().serializeToString(node);
var useFetcher = async (resources, fetcher2) => {
  const results = [];
  const promises = resources.map(async (resource) => {
    const result = await fetcher2(removeQuotes(descape(resource)));
    results.push([resource, result]);
  });
  await Promise.all(promises);
  return results;
};
var buildSvgDataURI = async (node, options) => {
  let css = "";
  let { width, height } = options;
  for (const styleSheet of document.styleSheets) {
    if (!styleSheet.href || styleSheet.href.startsWith(window.location.origin)) {
      for (const { cssText } of styleSheet.cssRules) {
        css += cssText;
      }
    }
  }
  if (typeof options.css === "function") {
    let result = await options.css(css);
    if (result)
      css = result;
  }
  let content = serialize(node);
  if (options.fetcher) {
    let resources = getUrlsFromCss(css);
    resources = resources.concat(getImageUrlsFromHtml(content));
    resources = resources.concat(getUrlsFromCss(content));
    let uniqueResources = Array.from(new Set(resources));
    if (options.filterer) {
      uniqueResources = uniqueResources.filter(options.filterer);
    }
    const base64Resources = await useFetcher(uniqueResources, options.fetcher);
    for (const [url, base64] of base64Resources) {
      css = css.replaceAll(url, base64);
      content = content.replaceAll(url, base64);
    }
  }
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'><foreignObject x='0' y='0' width='${width}' height='${height}'><style>${css}</style>${content}</foreignObject></svg>`;
  const dataURI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  return dataURI;
};
var renderToBase64Png = (dataURI) => {
  return new Promise((resolve) => {
    const img = document.createElement("img");
    const controller = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const png = canvas.toDataURL("image/png", 1);
      resolve(png);
    };
    img.src = dataURI;
    img.onload = controller;
    img.onerror = controller;
  });
};
export {
  buildSvgDataURI,
  fetcher,
  renderToBase64Png
};
